<template>
  <div>
    <OfferSortButton
      :is-active="sortMode !== DEFAULT_SORT_MODE"
      :disabled="offersLength <= 1"
    >
      {{
        sortMode !== DEFAULT_SORT_MODE
          ? t(`search.sorting.mode.${sortMode}`)
          : t('search.sorting.title')
      }}
    </OfferSortButton>
    <Teleport to="body">
      <FreeBottomSheet :name="sortingBottomSheet.name">
        <template #header>
          <FreeHeader class="h-16 p-4" style="--free-header-action-width: auto">
            <template #default>
              <h1 class="text-text-neutral-primary text-base font-medium">
                {{ t('search.sorting.title') }}
              </h1>
            </template>
            <template #rightAction>
              <FreeButton
                type="button"
                class="gray-button w-20 px-4 py-1 text-xs font-medium"
                :disabled="sortMode === DEFAULT_SORT_MODE"
                @click="onReset"
              >
                {{ t('general.clear') }}
              </FreeButton>
            </template>
          </FreeHeader>
        </template>
        <template #default>
          <div class="mx-4 mb-6">
            <div
              class="text-text-neutral-primary bg-background-neutral-secondary divide-situational-lightgrey divide-y rounded-2xl px-4 text-base font-medium"
            >
              <FreeRadio
                v-for="mode in Object.values(offerSortModel.SORT_MODES)"
                :key="mode"
                :checked="mode === sortMode"
                name="sortMode"
                class="justify-between py-4"
                @change="onChange(mode)"
              >
                <template #text>
                  {{ t(`search.sorting.mode.${mode}`) }}
                </template>
              </FreeRadio>
            </div>
          </div>
        </template>
      </FreeBottomSheet>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
  import {
    FreeBottomSheet,
    FreeButton,
    FreeHeader,
    FreeRadio,
  } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';

  import {
    offerSortModel,
    type SortMode,
    DEFAULT_SORT_MODE,
  } from '@/features/offer-sort';

  import { analyticsEventsLib } from '@/shared/lib';

  import OfferSortButton from './OfferSortButton.vue';

  const { t } = useI18n();

  defineProps<{
    offersLength: number;
    sortMode: SortMode;
  }>();

  const emit = defineEmits<{
    onChangeSortMode: [sortMode: SortMode];
  }>();

  const sortingBottomSheet = offerSortModel.sortingBottomSheetController();

  function onChange(sortMode: SortMode) {
    analyticsEventsLib.changeSortMode({ sortMode });
    emit('onChangeSortMode', sortMode);
    sortingBottomSheet.hide();
  }

  function onReset() {
    analyticsEventsLib.resetFiltersClick('sort');
    onChange(DEFAULT_SORT_MODE);
  }
</script>
